import { render, staticRenderFns } from "./ButtonBackHomeCategory.vue?vue&type=template&id=f90f6592&scoped=true&"
import script from "./ButtonBackHomeCategory.vue?vue&type=script&lang=js&"
export * from "./ButtonBackHomeCategory.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBackHomeCategory.vue?vue&type=style&index=0&id=f90f6592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90f6592",
  null
  
)

export default component.exports